<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'monthly_report_download' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-md-3 col-sm-6">
            <div class="input-group">
              <div class="input-group-addon">
                {{'monthly_report_filter_text' | translate}}
              </div>
              <vue-monthly-picker
                dateFormat="MM-YYYY"
                class="form-control"
                v-model="reportMonth"
                :max="max"
                :monthLabels="monthLabels"
                @selected="setPathEmpty"
              >
              </vue-monthly-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="row col-xs-12">
          <p>
            {{'download_reports_text' | translate}}
          </p>
          <template v-if="path === ''">
            <button
              class="btn btn-info"
              data-toggle="tooltip"
              data-placement="bottom"
              @click="downloadReport()"
              :disabled="loading"
            >
              <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-cloud-download', 'mr-5']"></i>
              Anfordern
            </button>
          </template>
          <template v-else>
            <a
              class="btn btn-success"
              data-toggle="tooltip"
              data-placement="bottom"
              :href="path"
              download
            >
              <i class="fa fa-download mr-5"></i>
              Download
            </a>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'
export default {
  name: 'monthlyReports',
  data () {
    return {
      loading: false,
      path: '',
      max: moment().subtract(1, 'month'),
      reportMonth: moment().subtract(1, 'month'),
      monthLabels: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
      trueValue: ''
    }
  },
  components: {
    VueMonthlyPicker: VueMonthlyPicker
  },
  methods: {
    downloadReport () {
      this.loading = true
      this.trueValue = ((typeof this.reportMonth._i) === 'undefined') ? this.reportMonth.format('YYYY-MM') : this.reportMonth._i.replace('/', '-')
      API.post('download/reports/monthly', {report_month: this.trueValue})
        .then(response => {
          this.path = response.data.path
          this.loading = false
        })
        .then(() => {
          this.loading = false
        })
    },
    setPathEmpty () {
      this.path = ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
  .picker:not(.month-year-label) {
    background: #212228;
  }
  .picker > .flexbox:not(.monthItem) {
    background-color: rgba(0,195,150,.075);
    border-color: #00C396;
    color: #00C396;
    font-weight: 600;
  }
  .picker > .flexbox.monthItem {
    background-color: #212228 ;
    color: white;
    font-weight: 600;
    border-top: 1px solid rgba(255,255,255, .15) !important;
  }
  .picker .monthItem .item:hover {
    background-color: #00C396 !important;
  }
  .date-popover{
    background: none !important;
    border: 1px solid rgba(255,255,255, .15) !important
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/Reports.vue